import { LocaleEnum } from '@systemeio/ui'

export const transformLocaleToPublicLocale = (locale?: LocaleEnum) => {
  switch (locale) {
    case undefined:
    case LocaleEnum.ENGLISH:
      return ''
    case LocaleEnum.TURKISH:
      return 'tur'
    default:
      return `${locale}`
  }
}

export const getPublicPath = (locale?: LocaleEnum, rest = '') => {
  const publicLocale = transformLocaleToPublicLocale(locale)

  if (!rest) {
    return `/${publicLocale}`
  }

  const normalizedPath = rest.startsWith('/') ? rest : `/${rest}`

  return publicLocale ? `/${publicLocale}${normalizedPath}` : normalizedPath
}
